import Vue from 'vue'
//引入element-ui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
//引入vue-router
import router from './router/index'
import VueRouter from 'vue-router'
import App from './App.vue'
import './assets/until/flexible.js';
//引入组件
import Component from '@/utils/index.js'

Vue.prototype.httpUrl = "https://api.yunjinyinxiangji.cn"
Vue.prototype.uploadimg = "https://api.yunjinyinxiangji.cn/api/yuesaoapplet/index/uploadimg"

//引入API
import API from '@/request/api';
Vue.prototype.$api = API;

//使用element-ui
Vue.use(ElementUI);
//使用vue-router
Vue.use(VueRouter)
//全局注册组件
Vue.use(Component)

Vue.config.productionTip = false
Vue.config.ignoredElements = ['wx-open-launch-weapp']

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
